import { render, staticRenderFns } from "./certificateAuditList-rzw.vue?vue&type=template&id=70c9a641&scoped=true&"
import script from "./certificateAuditList-rzw.vue?vue&type=script&lang=js&"
export * from "./certificateAuditList-rzw.vue?vue&type=script&lang=js&"
import style0 from "./certificateAuditList-rzw.vue?vue&type=style&index=0&id=70c9a641&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c9a641",
  null
  
)

export default component.exports